import { useRef } from "react";

import { Dialog, DialogContent } from "@/components/ui/dialog";

import { ConfirmationDialogBody } from "./ConfirmationDialogBody";
import type { IConfirmationDialogProps } from "./types";
import { getResolvedTestId } from "./utils";

export const ConfirmationDialog = (
  props: IConfirmationDialogProps,
): JSX.Element => {
  const {
    open: isOpen,
    onOpenChange,
    content,
    actions,
    testIdPrefix,
    classNames,
    dialogContentProps,
  } = props;
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        autoFocus={false}
        data-testid={getResolvedTestId({
          testIdPrefix,
          suffix: "dialog",
        })}
        {...dialogContentProps}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
          cancelRef.current?.focus();
        }}
      >
        <ConfirmationDialogBody
          content={content}
          actions={{
            onCancel: () => onOpenChange(false),
            ...actions,
          }}
          cancelRef={cancelRef}
          testIdPrefix={testIdPrefix}
          classNames={classNames}
        />
      </DialogContent>
    </Dialog>
  );
};
